import Vue from 'vue'

const mutations = {
  SET_HOLIDAYSETLIST (state, holidayset) {
    Vue.set(state, 'holidayset_list', holidayset)
  },
  ADD_HOLIDAYSET (state, holidayset) {
    if (!state.holidayset_list.find(dts => dts.id === holidayset.id)) {
      state.holidayset_list.push(holidayset)
    }
  },
  UPDATE_HOLIDAYSET_IN_HOLIDAYSETLIST (state, holidayset) {
    let updatedHolidaysetIndex = state.holidayset_list.findIndex(oldHolidayset => oldHolidayset.id === holidayset.id)
    if (updatedHolidaysetIndex === -1) {
      return
    }
    Vue.set(state.holidayset_list, updatedHolidaysetIndex, holidayset)
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/holidayset/holidayset.mutations.js
// module id = null
// module chunks = 